import { useFetch } from 'hooks/use-fetch/use-fetch';
import { IPagination } from 'hooks/use-table/use-table.props';
import { useQuery } from '@tanstack/react-query';
import { DriverLevelQueryKeys } from '../driver-level.props';
import { DriverLevelListResponse } from './driver-level.props';
import { driverLevelRequestConfig } from 'request-config/driver-level/driver-level.request-config';
import { AxiosResponse } from 'axios';

const modifyResponse = (data: AxiosResponse<DriverLevelListResponse>): DriverLevelListResponse => {
  if (data.status === 200) {
    return data.data;
  }

  return defaultQuery;
};

export const useDriverLevelListQuery = (
  pagination: IPagination | {},
  enabled: boolean = true,
  isShowLoading: boolean = true
) => {
  const { fetch } = useFetch<DriverLevelListResponse>({
    loadingKey: `driverLevelCompanyList${JSON.stringify(pagination)}`,
    isShowLoading,
    ...driverLevelRequestConfig.companyList(pagination)
  });

  const { data, ...restQueryProps } = useQuery<
    AxiosResponse<DriverLevelListResponse>,
    unknown,
    DriverLevelListResponse
  >({
    queryKey: [DriverLevelQueryKeys.CompanyList, pagination],
    queryFn: () => fetch(),
    enabled,
    select: modifyResponse
  });

  return { driverLevelListQuery: data || defaultQuery, ...restQueryProps };
};

const defaultQuery: DriverLevelListResponse = {
  items: [],
  totalRecord: 0,
  numberOfPages: 0
};
